import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { listAdminPosts } from "@/lib/posts.functions";
import { listApprovedThemes } from "@/lib/themes-public.functions";
import { PostsList } from "@/components/admin-workspace/PostsList";
import type { ListRow, ThemeKey } from "@/components/admin-workspace/model";

export const Route = createFileRoute("/admin/icerik")({
  head: () => ({ meta: [{ title: "Yazılar · Yönetim" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: Page,
});

function Page() {
  const navigate = useNavigate();
  const list = useServerFn(listAdminPosts);
  const themesFn = useServerFn(listApprovedThemes);
  const { data, isLoading } = useQuery({ queryKey: ["admin-posts"], queryFn: () => list() });
  // Read-only: shows the approved theme decision; never assigns or changes it.
  const { data: approved } = useQuery({ queryKey: ["admin-approved-themes"], queryFn: () => themesFn() });
  const approvedThemes = new Map<string, ThemeKey>((approved ?? []).map((t) => [t.slug, t.primary as ThemeKey]));
  return (
    <PostsList
      posts={(data?.posts ?? []) as ListRow[]}
      approvedThemes={approvedThemes}
      loading={isLoading}
      onOpen={(id) => navigate({ to: "/admin/yazi/$id", params: { id } })}
      onNew={() => navigate({ to: "/admin/yazi/yeni" })}
    />
  );
}
